import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cm-sidebar-filters',
  templateUrl: './sidebar-filters.component.html',
  styleUrls: ['./sidebar-filters.component.scss'],
})
export class SidebarFiltersComponent {
  @Input() filtersTitle = 'Filters';
  @Input() count: number;
  @Output() closeSideBar: EventEmitter<string> = new EventEmitter();
  @Output() resetFilters: EventEmitter<string> = new EventEmitter();
}
